/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_GenerateInputs */

const cs_draft_generate = /** @type {(inputs: Draft_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vygenerovat`)
};

const en_draft_generate = /** @type {(inputs: Draft_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate`)
};

/**
* | output |
* | --- |
* | "Generate" |
*
* @param {Draft_GenerateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_generate = /** @type {((inputs?: Draft_GenerateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_GenerateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_generate(inputs)
	return cs_draft_generate(inputs)
});